import get from 'lodash/get';
import { initialGeneratorParams } from '@shakkerai/pro-constants';
import { getProjectState, updateTask, getSharedData } from '@starflow/app/store';
import { getPositionInfo } from '@starflow/app/helpers/viewport';
import { SegmentEditor } from '@starflow/app/components/common/SegmentEditor';
import { enterDerivativeFromUnit } from '../../derivative';
import { translate } from '@shakkerai/util-i18n';

// 流节点的能力描述
// 1. 包含输入参数和输出参数，并且输入和输出的端口都是动态的
// 2. 包含执行函数，用于执行功能模块的功能
// 3. 可以注册新的画布元素
// 4. 可以在应用的各个预设位置渲染自定义的UI组件
// 5. 可以暴露出一些方法供其他功能模块调用
// 6. 可以在应用初始化时进行一些初始化操作
// 7. 有一些生命周期函数，用于在特定的时机执行一些操作

const baseInputPorts = [
  {
    name: 'sourceElement',
    type: 'image',
    label: '原图',
  },
];

const baseOutputPorts = [
  {
    name: 'items',
    type: 'images',
  },
];

export default {
  type: 'outpaint',

  title: translate('imagetool_outpaint'),
  isAI: true,
  isFlowUnit: true, // 是否是流程单元

  // 默认数据，可以是个函数，返回默认数据，也可以直接是一个对象
  defaultData(incomingData) {
    const defaultData = {
      ...initialGeneratorParams.outpaint,
      ...incomingData,
      width: 768,
      height: 1024,
      segments: SegmentEditor.defaultValue,
    };

    if (incomingData.sourceElement?.id) {
      const element = getProjectState('elements').find((element) => element.id === incomingData.sourceElement.id);

      if (element) {
        defaultData.width = element.width;
        defaultData.height = element.height;
      }
    }

    return defaultData;
  },

  extractProjectData: (data) => {
    // 旧数据兼容
    if (data.sourceImage && !data.sourceElement) {
      data.sourceElement = data.sourceImage;
    }

    return data;
  },

  methods: {},

  // 获取输入端口
  getInputPorts(data) {
    return baseInputPorts;
  },

  // 获取输出端口
  getOutputPorts(data) {
    return baseOutputPorts;
  },

  // 设置输入
  applyInput(name, value, data) {
    return { ...data, [name]: value };
  },

  // 获取全部输入或者单个输入
  getInputs(data, name) {
    if (!name) {
      const inputPorts = this.getInputPorts(data);

      return inputPorts.map((port) => ({
        name: port.name,
        type: port.type,
        value: get(data, port.name),
        label: port.label,
      }));
    }

    return get(data, name);
  },

  // 获取输出
  getOutput(name, node) {
    return name ? node.result[name] : node.result;
  },

  onNodeClick(data) {
    enterDerivativeFromUnit('outpaint', data);
  },

  onDataUpdate(data, app) {},

  onFocus(data, app) {},

  onBeforeExecute(data, app) {},

  onAfterExecute(data, app) {},

  async resume({ data, app }) {
    await app.modules.generator.methods.resumeGeneration(data);
  },

  // 执行函数
  async execute({ data, app }) {
    const generateParams = {
      ...data.params,
    };

    if (data.isAuto) {
      const positionInfo = getSharedData('autoRunningPositionInfo') ?? getPositionInfo(data);
      updateTask(data.id, positionInfo);
    } else {
      const sourceElement = getProjectState('nodeMap')[data.unitId].data.data.sourceElement;
      generateParams.sourceElement = sourceElement;
    }

    await app.modules.generator.methods.submitGeneration({ ...data, params: generateParams });
  },
};
